import React, { createContext, useContext, useMemo } from 'react';
import { ELEMENT_SYMBOLS } from '../config/elements';

const ChemistryContext = createContext(null);

export function ChemistryProvider({ children }) {
  const validElements = useMemo(() => new Set(ELEMENT_SYMBOLS), []);
  const isValidElement = (sym) => validElements.has(sym);
  const value = { validElements, isValidElement };
  return <ChemistryContext.Provider value={value}>{children}</ChemistryContext.Provider>;
}

export function useChemistry() {
  const ctx = useContext(ChemistryContext);
  if (!ctx) throw new Error('useChemistry must be used within ChemistryProvider');
  return ctx;
}
